import Reveal from "@/components/Reveal";
import { CONTACT } from "@/data/products";

const SECTIONS = [
  {
    title: "1. Information We Collect",
    body: "When you contact us through the enquiry form on this website, we collect your name, phone number and message. When you reach us via phone, WhatsApp or email, we receive the details you choose to share with us.",
  },
  {
    title: "2. How We Use Your Information",
    body: "Your details are used only to respond to your enquiry, confirm orders, arrange home delivery and share price or availability updates you have asked for. We do not use your information for unrelated marketing.",
  },
  {
    title: "3. Sharing of Information",
    body: "We do not sell, rent or share your personal information with any third party. Your details stay within Raj Kumari Kirana Store.",
  },
  {
    title: "4. Cookies & Tracking",
    body: "This website does not use advertising trackers. Any basic technical storage is used only to make the site function properly.",
  },
  {
    title: "5. Data Security",
    body: "Enquiry details are stored securely and accessed only to serve your request. If you would like your enquiry details removed, simply ask us.",
  },
  {
    title: "6. Third-Party Links",
    body: "This site links to WhatsApp and standard phone/email services. Their own privacy policies apply when you use those services.",
  },
  {
    title: "7. Contact",
    body: `For any privacy question, reach us at ${CONTACT.email} or call ${CONTACT.phone}.`,
  },
];

const Privacy = () => (
  <main className="pt-32 pb-24 px-6 md:px-10 min-h-screen">
    <div className="max-w-3xl mx-auto">
      <Reveal>
        <p className="uppercase text-xs sm:text-sm font-semibold tracking-[0.2em] text-spice">Legal</p>
        <h1 className="font-serif font-bold tracking-tight text-ink text-4xl sm:text-5xl mt-4">Privacy Policy</h1>
        <p className="text-mut text-sm mt-4">Effective July 2026 · Raj Kumari Kirana Store</p>
      </Reveal>
      <div className="mt-12 flex flex-col gap-10">
        {SECTIONS.map((s, i) => (
          <Reveal key={s.title} delay={i * 0.04}>
            <h2 className="font-serif font-semibold text-coffee text-xl md:text-2xl">{s.title}</h2>
            <p className="text-bark leading-relaxed mt-3 text-sm md:text-base">{s.body}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </main>
);

export default Privacy;
